"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const Button = (props) => {
    const { type = "primary", size = "small", children, disabled = false, onClick } = props;
    return (react_1.default.createElement("button", { disabled: disabled, onClick: onClick, className: (0, classnames_1.default)(`c-button c-button--${type} c-button--${size}`, { "c-button--disabled": disabled }) }, children));
};
exports.Button = Button;
